// extracted by mini-css-extract-plugin
module.exports = {"userItem":"SideBarUserItem_userItem__Kn00S","nameText":"SideBarUserItem_nameText__ZCHim"};